export var mutations = {
    setLatestCandidates: function (s, payload) { return s.latestCandidates = payload; },
    setLoading: function (s, payload) { return s.loading = payload; },
};
